import EditorialGuide from 'components/Shared/EditorialGuide';
import GetInTouch from 'components/Shared/GetInTouch';
import Breadcrumbs from 'components/ui/Breadcrumbs';
import { useTranslation } from 'hooks/useTranslation';
import styles from './AuthorList.module.scss';
import List from './List';
import type { IAuthorFields } from 'types/contentful/generated';

type Props = {
  entry: {
    authorList: { fields: IAuthorFields }[];
    fields: {
      title: string;
    };
  };
};

const AuthorList = ({ entry }: Props): JSX.Element => {
  const { t } = useTranslation();

  const breadcrumbs = [
    {
      link: t('authors').toLowerCase(),
      title: entry.fields.title,
    },
  ];

  return (
    <>
      <div className="bg-blueTurquoise">
        <Breadcrumbs
          containerClassNames={styles.breadcrumbsContainer}
          className={styles.breadcrumbs}
          crumbs={breadcrumbs}
        />
        <div className={styles.headlineWrapper}>
          <h1 className={styles.headline}>{entry.fields.title}</h1>
        </div>
      </div>
      <div className={styles.listWrapper}>
        <List entry={entry} />
        <div className={styles.guide}>
          <EditorialGuide />
        </div>
      </div>
      <GetInTouch />
    </>
  );
};

export default AuthorList;
